import { Container, Grid } from "@mui/material";
import * as React from "react";
import LoanCalculatorForm from "../../Components/LoanCalculatorForm/LoanCalculatorForm";

import Box from "@mui/material/Box";
import { LoanCalcultaorTitleContainer } from "../../pages/LoanCalculator/LoanCalculatorUI.styles";

export default function LoanCalculator() {
  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 1 }}>
      <Grid container sx={{ mt: 2, mb: 2 }}>
        <Box sx={{ width: "85%", marginLeft: "100px" }}>
          <LoanCalcultaorTitleContainer>
            SWAN CAPITAL SOLUTIONS
          </LoanCalcultaorTitleContainer>
          <>
            <LoanCalculatorForm />
          </>
        </Box>
      </Grid>
    </Container>
  );
}
